import { InferType, ObjectSchema } from 'yup';

import { HTTPRequestServicePayload, Method } from 'common/services/http/types';

import apiRequestService from '../apiRequestService';

type TypedApiRequestServicePayload<SchemeType extends object> = {
  httpMethod?: Method;
  method: string;
  query?: Record<string, any>;
  validationScheme?: ObjectSchema<Nullable<SchemeType>>;
  customHost?: string;
  customPathName?: string;
} & Pick<HTTPRequestServicePayload, 'body' | 'headers'>;

type TypedApiRequestServiceResponse<SchemeType extends object> = InferType<
  ObjectSchema<SchemeType>
>;

const { hostname } = window.location;
const isProd = hostname.endsWith('.com');
const isStage = hostname.endsWith('.dev');

const typedApiRequestService = <SchemeType extends object>({
  validationScheme,
  httpMethod,
  method,
  query,
  body,
  headers,
  customHost,
  customPathName,
}: TypedApiRequestServicePayload<SchemeType>): Promise<
  TypedApiRequestServiceResponse<SchemeType>
> =>
  new Promise((resolve, reject) =>
    apiRequestService<TypedApiRequestServiceResponse<SchemeType>>({
      httpMethod,
      method,
      query,
      body,
      headers,
      customHost,
      customPathName,
    }).then((response) => {
      if (!isProd && !isStage && validationScheme) {
        try {
          validationScheme.validateSync(response, {
            strict: true,
            abortEarly: true,
          });
          // TODO: add body parser if it need
        } catch (e) {
          console.error('typedApiRequestService', e);
          reject(e);
        }
      }

      resolve(response);
    }, reject),
  );

export default typedApiRequestService;
